import React from 'react';

interface CodeLibraryIconProps {
  className?: string;
  size?: number;
}

const CodeLibraryIcon: React.FC<CodeLibraryIconProps> = ({ className, size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect opacity="0.01" width="16" height="16" rx="1" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5903 0.933594H1.50262C1.18788 0.933594 0.933594 1.18788 0.933594 1.50262V14.5903C0.933594 14.905 1.18788 15.1593 1.50262 15.1593H14.5903C14.905 15.1593 15.1593 14.905 15.1593 14.5903V1.50262C15.1593 1.18788 14.905 0.933594 14.5903 0.933594ZM8.06682 8.15502L4.65265 11.0179C4.56018 11.0962 4.4197 11.0304 4.4197 10.9095V9.79454C4.4197 9.75364 4.43927 9.71274 4.47127 9.68606L5.51175 8.81237C5.98767 8.41273 5.98767 7.68037 5.51175 7.28074L4.47127 6.40704C4.43749 6.38037 4.4197 6.34125 4.4197 6.29857V5.18363C4.4197 5.06271 4.56018 4.99692 4.65265 5.07516L8.06682 7.9363C8.13439 7.99321 8.13439 8.09812 8.06682 8.15502ZM8.25446 11.0473C8.18155 11.0473 8.12109 10.9833 8.12109 10.9051V10.0515C8.12109 9.9733 8.18155 9.90929 8.25446 9.90929H11.5442C11.6171 9.90929 11.6775 9.9733 11.6775 10.0515V10.9051C11.6775 10.9833 11.6171 11.0473 11.5442 11.0473H8.25446ZM2.21484 12.8799C2.21484 13.4322 2.66256 13.8799 3.21484 13.8799H12.8799C13.4322 13.8799 13.8799 13.4322 13.8799 12.8799V3.21484C13.8799 2.66256 13.4322 2.21484 12.8799 2.21484H3.21484C2.66256 2.21484 2.21484 2.66256 2.21484 3.21484V12.8799Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CodeLibraryIcon;
